export const broadcastTypes: { [key: string]: string } = {
    prerecorded: "Prerecorded",
    live: "Live",
}